import { render, staticRenderFns } from "./NewFundMarketHeader.vue?vue&type=template&id=132ed1ea&scoped=true&"
import script from "./NewFundMarketHeader.vue?vue&type=script&lang=js&"
export * from "./NewFundMarketHeader.vue?vue&type=script&lang=js&"
import style0 from "./NewFundMarketHeader.vue?vue&type=style&index=0&id=132ed1ea&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132ed1ea",
  null
  
)

export default component.exports